<template>
    <div class="row header-row hcol-1">
        <div class="col-5 logo-col">
            <div class="logo-ct pl-5 py-2 pr-3">
                <wingo-logo-teal />
            </div>
        </div>
        <div class="col-7 text-right misc-col pr-5 py-2 pl-3">
            <div v-if="points !== null" class="counter"><span id="points">{{ points ? points : 0}}</span>{{$t('total_points')}}</div>
        </div>
    </div>
</template>
<script>
import WingoLogoTeal from '@/assets/img/wingo-logo-teal';
export default {
    components: {
        WingoLogoTeal
    },
    props: [
        "points"
    ]
}
</script>